<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Vendor Code</em>
				<span class="int_type_no_border mgr_15">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<label for="class_active_yn" class="mgr_5"><input type="checkbox" id="class_active_yn" v-model="class_active_yn" true-value="Y" false-value="N" /> {{ headers.class }} Active </label>
				<label v-if="!isNewjigu" for="lockPrice" class="mgr_5"> <input type="checkbox" id="lockPrice" v-model="lockPrice" @change="setDefaultHeader()" /> Lock Price </label>
				<label v-if="!isNewjigu" for="fob" class="mgr_5"> <input type="checkbox" id="fob" v-model="fob" @change="setDefaultHeader()" /> FOB </label>
				<label v-if="!isNewjigu" for="item_need" class="mgr_5"> <input type="checkbox" id="item_need" v-model="isFilteredByNeed" @change="setDisplayRecords()" /> Filter By Need </label>
				<label class="mgr_5"><input type="checkbox" v-model="itemClassesOrderYn" true-value="Y" false-value="N" /> Order by Selected Item {{ headers.class }}</label>

				<item-class-select-multi-s v-model="itemClasses" ref="ItemClassSelectMulti" />

				<SelectUserDefinedGroup v-model="user_defined_group" ref="user_defined_group" :display-all="false" />
				<em class="lt_text">Group</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :descWidth="100" :codes="classGroups" v-model="classGroup" /> </span>

				<em class="lt_text">Category</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :nameWidth="500" :codes="categories" :showDesc="false" v-model="category" /> </span>

				<item-department-a v-model="deptA" />
				<item-department-b v-model="deptB" />
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
				<font color="red"><b>Takes long time without search condition(s) </b></font>
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<CommonTable :tbl_headers="tbl_headers" :data="display_records" @selectPurchase="selectPurchase" @selectShipment="selectShipment" />
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
				<li>
					<a v-if="!isNewjigu" href="javascript:void(0);" v-on:click="print">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import CodeSelect from '@/components/common/CodeSelect';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import ItemDepartmentA from '@/components/common/ItemDepartmentA';
import ItemDepartmentB from '@/components/common/ItemDepartmentB';
import SelectUserDefinedGroup from '@/components/common/SelectUserDefinedGroup';

import { PrintType, apiGetReportTemplate, exportDataExcel, objectToFormData, Report, companyMrtUrl, objectCopy } from '@/api/util';
import { apiVendorAnalyzeItem } from '@/api/report/report';
import { defaultDataType } from 'export-xlsx';
import { apiIndex } from '@/api/item/class';

export default {
	props: ['headers'],
	data: function() {
		return {
			classGroups: [],
			categories: [],
			vendorCode: null,
			classGroup: null,
			category: null,
			lockPrice: false,
			fob: false,
			isFilteredByNeed: false,
			deptA: '',
			deptB: '',
			itemClassesOrderYn: '',
			root: {
				value: [],
			},
			itemClasses: [],
			user_defined_group: '',
			class_active_yn: 'Y',

			tbl_headers: [],
			display_data: [],
			display_records: [],
		};
	},
	components: {
		ItemDepartmentA,
		ItemDepartmentB,
		PartnerSelect,
		CodeSelect,
		ItemClassSelectMultiS,
		SelectUserDefinedGroup,
		CommonTable,
	},
	computed: {
		isBeautyPlus() {
			return this.$session.get('company').company_id === 'beautyplus';
		},
		isHairPlus() {
			return this.$session.get('company').company_id === 'hairplus';
		},
		isNewjigu() {
			return this.$session.get('company').company_id === 'newjigu';
		},
		isBeautyPlusOrHairPlus() {
			return this.isBeautyPlus || this.isHairPlus;
		},
		user_defined_group_list() {
			return this.user_defined_group.split('|');
		},
	},
	methods: {
		row(value, item, po, ship) {
			let record = {};
			this.setValue(value, record);
			this.setValue(item, record);
			this.setValue(po, record);
			this.setValue(ship, record);

			return record;
		},
		setValue: function(item, record) {
			if (item) for (let key of Object.keys(item)) if ('list' !== key) record[key] = item[key];
		},
		listCheck(obj) {
			return obj.list && obj.list.length > 0;
		},
		indexCheck(indexList) {
			let a = true;
			indexList.forEach(function(value) {
				if (value !== 0) a = false;
			});
			return a;
		},
		zeroAndValue(value) {
			return value < 0 ? 0 : value;
		},
		/**
		 * 0 이하의 값은 0으로 대체
		 * @param item
		 */
		rowValueChange(item) {
			if (this.isBeautyPlus) {
				item.availableQty = this.zeroAndValue(item.availableQty);
				item.onHand = this.zeroAndValue(item.onHand);
				item.underHand = this.zeroAndValue(item.underHand);
				item.totalHand = this.zeroAndValue(item.totalHand);
				item.ytd = this.zeroAndValue(item.ytd);
				item.qtd = this.zeroAndValue(item.qtd);
				item.mtd = this.zeroAndValue(item.mtd);
				item.w2td = this.zeroAndValue(item.w2td);
			}
		},

		selectPurchase(recode) {
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: recode.po_no } });
			window.open(routeData.href, '_blank');
		},
		selectShipment(recode) {
			let routeData = this.$router.resolve({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, sh_no: recode.sh_no } });
			window.open(routeData.href, '_blank');
		},

		reset() {
			this.itemClassesOrderYn = '';
			this.vendorCode = null;
			this.classGroup = null;
			this.category = null;
			this.$refs.ItemClassSelectMulti.reset();
			this.root.value = [];
		},
		setPartner(partner) {
			this.vendorCode = partner.code;
			this.search();
		},
		async search() {
			const paramObj = {
				itemClasses: this.itemClasses,
				vendorCode: this.vendorCode,
				classGroup: this.classGroup,
				category: this.category,
				lockPrice: this.lockPrice,
				deptA: this.deptA,
				deptB: this.deptB,
				itemClassesOrderYn: this.itemClassesOrderYn,
				user_defined_group: this.user_defined_group_list,
				class_active_yn: this.class_active_yn,
			};

			// console.log(paramObj);
			const param = objectToFormData(paramObj);
			const { data } = await apiVendorAnalyzeItem(param);

			this.root = data && Array.isArray(data.value) ? data : { value: [] };
			this.calcNeed();
			this.setDisplayRecords();
		},
		calcNeed() {
			this.root.value.forEach(cls => {
				if (cls.list && Array.isArray(cls.list)) {
					for (let i = 0; i < cls.list.length; i++) {
						const item = cls.list[i];
						const need = item.mtd * 3 - (item.onHand + item.underHand);
						item.need = need < 0 ? 0 : need;
					}
				}
			});
		},
		setDisplayRecords() {
			this.display_data = this.isFilteredByNeed ? this.filterByNeed() : this.root.value;
			this.display_records = this.isNewjigu ? this.combinePOWithShipments() : this.makeRecords();
		},
		filterByNeed() {
			const result = [];
			this.root.value.forEach(cls => {
				if (cls.list && Array.isArray(cls.list)) {
					const item_list = cls.list.filter(item => item.need);
					if (item_list.length > 0) {
						const cls_copy = {};
						this.setValue(cls, cls_copy);
						cls_copy.list = item_list;
						result.push(cls_copy);
					}
				}
			});

			return result;
		},
		makeRecords() {
			let records = [];
			const vm = this;
			this.display_data.forEach(function(value) {
				let availableQty = 0;
				let onHand = 0;
				let totalHand = 0;
				let ord = 0;
				let ytd = 0;
				let qtd = 0;
				let mtd = 0;
				let wkTd = 0;
				value.list.forEach(function(item, itemIndex) {
					vm.rowValueChange(item);
					availableQty += item.availableQty;
					onHand += item.onHand;
					ord += item.underHand;
					totalHand += item.totalHand;
					ytd += item.ytd;
					qtd += item.qtd;
					mtd += item.mtd;
					wkTd += item.w2td;
					if (vm.listCheck(item)) {
						item.list.forEach(function(po, poIndex) {
							if (vm.listCheck(po)) {
								po.list.forEach(function(ship, shipIndex) {
									if (vm.indexCheck([poIndex, itemIndex, shipIndex])) {
										records.push(vm.row(value, item, po, ship));
									} else if (vm.indexCheck([poIndex, shipIndex])) {
										records.push(vm.row(undefined, item, po, ship));
									} else if (vm.indexCheck([shipIndex])) {
										records.push(vm.row(undefined, undefined, po, ship));
									} else {
										records.push(vm.row(undefined, undefined, undefined, ship));
									}
								});
							} else {
								if (vm.indexCheck([poIndex, itemIndex])) {
									records.push(vm.row(value, item, po));
								} else if (vm.indexCheck([poIndex])) {
									records.push(vm.row(undefined, item, po));
								} else {
									records.push(vm.row(undefined, undefined, po));
								}
							}
						});
					} else {
						if (vm.indexCheck([itemIndex])) {
							records.push(vm.row(value, item));
						} else {
							records.push(vm.row(undefined, item));
						}
					}
				});
				const total = { colorCode: 'Total', availableQty: availableQty, onHand: onHand, underHand: ord, totalHand: totalHand, ytd: ytd, qtd: qtd, mtd: mtd, w2td: wkTd };
				records.push(vm.row(total));
			});
			return records;
		},
		combinePOWithShipments() {
			let records = [];

			this.display_data.forEach(value => {
				let availableQty = 0;
				let onHand = 0;
				let totalHand = 0;
				let ord = 0;
				let ytd = 0;
				let qtd = 0;
				let mtd = 0;
				let wkTd = 0;
				let ms1 = 0;
				let ms2 = 0;
				let ms3 = 0;
				let avg_3m = 0;
				let thisMonthSales = 0;
				let pend30 = 0;
				value.list.forEach(item => {
					this.rowValueChange(item);
					availableQty += item.availableQty;
					onHand += item.onHand;
					ord += item.underHand;
					totalHand += item.totalHand;
					ytd += item.ytd;
					qtd += item.qtd;
					mtd += item.mtd;
					wkTd += item.w2td;
					ms1 += item.ms1;
					ms2 += item.ms2;
					ms3 += item.ms3;
					avg_3m += item.avg_3m;
					thisMonthSales += item.thisMonthSales;
					pend30 += item.pend30;
					// item에 PO가 있는 경우
					if (this.listCheck(item)) {
						item.list.forEach((po, poIndex) => {
							let obj = null;
							if (this.indexCheck([poIndex])) {
								obj = this.row(value, item, po);
							} else {
								obj = this.row(value, undefined, po);
							}

							let on_board = 0;
							let eta = po.eta_date ? new Date(po.eta_date) : null;
							let eta_idx = -1;
							if (this.listCheck(po)) {
								po.list.forEach((ship, shipIndex) => {
									on_board += ship.bl_qty ? ship.bl_qty : 0;
									const arrival_date = ship.arrival_date ? new Date(ship.arrival_date) : null;
									if (!eta || (eta && arrival_date && eta.getTime() - arrival_date.getTime() > 0)) {
										eta = arrival_date;
										eta_idx = shipIndex;
									}
								});
							}

							obj.on_board = on_board;
							if (eta_idx > -1) {
								obj.eta_date = po.list[eta_idx].arrival_date;
								obj.estimated_ship_date = po.list[eta_idx].bl_date;
							}

							records.push(obj);
						});
					} else {
						// Item에 PO가 없는 경우
						// PO가 업을지라도, Vendor 위치에 Factory Code 표시 요청
						// const rec = this.row(this.indexCheck([itemIndex]) ? value : undefined, item);
						const rec = this.row(value, item);
						rec.vendor_code = value.factory_code;
						records.push(rec);
					}
				});
				const total = {
					colorCode: 'Total',
					availableQty: availableQty,
					onHand: onHand,
					underHand: ord,
					totalHand: totalHand,
					ytd: ytd,
					qtd: qtd,
					mtd: mtd,
					w2td: wkTd,
					ms1: ms1,
					ms2: ms2,
					ms3: ms3,
					avg_3m: avg_3m,
					thisMonthSales: thisMonthSales,
					pend30: pend30,
					id: value.classCode,
					tr_class: 'bg_gray',
				};
				records.push(this.row(total));
			});
			return records;
		},

		printData() {
			let data = { list: [] };
			const vm = this;
			this.display_data.forEach(function(value) {
				let records = [];
				value.list.forEach(function(item, itemIndex) {
					vm.rowValueChange(item);
					if (vm.listCheck(item)) {
						item.list.forEach(function(po, poIndex) {
							if (vm.listCheck(po)) {
								po.list.forEach(function(ship, shipIndex) {
									if (vm.indexCheck([poIndex, itemIndex, shipIndex])) {
										records.push(vm.row(value, item, po, ship));
									} else if (vm.indexCheck([poIndex, shipIndex])) {
										records.push(vm.row(undefined, item, po, ship));
									} else if (vm.indexCheck([shipIndex])) {
										records.push(vm.row(undefined, undefined, po, ship));
									} else {
										records.push(vm.row(undefined, undefined, undefined, ship));
									}
								});
							} else {
								if (vm.indexCheck([poIndex, itemIndex])) {
									records.push(vm.row(value, item, po));
								} else if (vm.indexCheck([poIndex])) {
									records.push(vm.row(undefined, item, po));
								} else {
									records.push(vm.row(undefined, undefined, po));
								}
							}
						});
					} else {
						if (vm.indexCheck([itemIndex])) {
							records.push(vm.row(value, item));
						} else {
							records.push(vm.row(undefined, item));
						}
					}
				});

				let cls = { className: value.className, classCode: value.classCode, list: records };
				data.list.push(cls);
			});
			data.vendor_name = this.root.vendor_name;
			data.vendor_code = this.root.vendor_code;
			data.item_class = this.root.item_class;
			data.class_group = this.root.class_group;
			data.lockPrice = this.lockPrice;
			data.fob = this.fob;

			return data;
		},
		async print() {
			//const reportTemplate = await apiGetReportTemplate('VendorAnalyzeItem', reportMrtUrl('VendorAnalyzeItem'));

			let pd = this.printData();
			//console.log(pd);
			// const dummy = 1;
			// if (dummy) return;
			const reportTemplate = await apiGetReportTemplate('VendorAnalyzeItem', companyMrtUrl('VendorAnalyzeItem'));
			//console.log(this.printData());
			const report = new Report(reportTemplate, pd, 'VendorAnalyzeItem', PrintType.Normal, false, false, null, 70);
			this.$store.commit('setReport', report);
		},
		excel() {
			let headers = this.tbl_headers;
			let excel_data = objectCopy(this.display_records);
			const fileName = 'VendorAnalyzeItem';

			let className = null;
			excel_data.forEach(el => {
				if (!el.className) el.className = className;
				else className = el.className;

				if (!el.need) el.need = null;
			});

			exportDataExcel(excel_data, headers, fileName);
		},

		setDefaultHeader() {
			if (this.isNewjigu) {
				this.lockPrice = true;
				this.tbl_headers = this.newgiguExcelHeader();
			} else {
				this.tbl_headers = this.defaultExcelHeader();
			}
		},
		newgiguExcelHeader() {
			return [
				{ key: 'groupName', name: 'GROUP', width: 10, dataType: defaultDataType.string, editable: true, tbl_width: '6%' },
				{ key: 'vendor_code', name: 'Vendor', width: 10, dataType: defaultDataType.string, editable: true, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'classCode', name: this.headers.class, width: 10, dataType: defaultDataType.string, editable: true, tbl_width: '6%' },
				{ key: 'className', name: `${this.headers.class} Name`, width: 20, dataType: defaultDataType.string, editable: true, tbl_width: '7%' },
				{ key: 'colorCode', name: 'Color', width: 10, dataType: defaultDataType.string, editable: true, tbl_width: '5%' },
				{ key: 'onHand', name: 'On Hand', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'availableQty', name: 'Avail', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'ms3', name: '3MS', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'ms2', name: '2MS', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'ms1', name: '1MS', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{
					key: 'avg_3m',
					name: '3MAVG',
					width: 10,
					dataType: defaultDataType.currency,
					style: { font: { bold: true, color: { argb: 'FFFF0000' } }, numFmt: '#,##0' },
					tbl_width: '4%',
					td_class: ['al_right', 'red_bold'],
					display_filter: 'commaSeparated',
				},
				{ key: 'thisMonthSales', name: 'MTD', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'pend30', name: 'PEND30', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'underHand', name: 'Und Ord', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'totalHand', name: 'Total Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'po_dn', name: 'PO No', width: 15, dataType: defaultDataType.string, tbl_width: '4%', click_event: 'selectPurchase' },
				{ key: 'po_qty', name: 'PO Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'po_date', name: 'PO Date', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'on_board', name: 'On Board', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'estimated_ship_date', name: 'ESD', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'eta_date', name: 'ETA', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'lockPrice', name: 'Lock Price', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'cost', name: 'COST', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'packing', name: 'Packing', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
			];
		},
		defaultExcelHeader() {
			const headers = [
				{ key: 'className', name: this.headers.class, width: 20, dataType: defaultDataType.string, tbl_width: '7%' },
				{ key: 'colorCode', name: 'Color', width: 20, dataType: defaultDataType.string, tbl_width: '5%' },
				{ key: 'availableQty', name: 'Avail', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'onHand', name: 'On Hand', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'underHand', name: 'Und Ord', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'totalHand', name: 'Total Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'ytd', name: 'Ytd', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'qtd', name: 'Qtd', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'mtd', name: 'Mtd', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'w2td', name: '2WkTd', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'po_dn', name: 'PO No', width: 15, dataType: defaultDataType.string, tbl_width: '4%', click_event: 'selectPurchase' },
				{ key: 'po_date', name: 'PO Date', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'vendor_code', name: 'Vendor', width: 20, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				//{ key: 'fob', name: 'FOB', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'po_delivery_type_code', name: 'Ship', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'po_qty', name: 'PO Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'sh_dn', name: 'SH No', width: 15, dataType: defaultDataType.string, tbl_width: '4%', click_event: 'selectShipment' },
				{ key: 'estimated_ship_date', name: 'ESD', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'arrival_date', name: 'ETA', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'bl_no', name: 'BL No', width: 15, dataType: defaultDataType.string, tbl_width: '4%' },
				{ key: 'bl_date', name: 'BL Date', width: 15, dataType: defaultDataType.date, tbl_width: '4%', td_class: 'al_center', display_filter: 'convertYMDToMDY' },
				{ key: 'bl_qty', name: 'BL Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'delivery_type_name', name: 'Delivery Type', width: 15, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'nothing', name: 'I', width: 5, dataType: defaultDataType.string, tbl_width: '4%' },
				{ key: 'need', name: 'Need', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated', display_default: '' },
			];

			if (this.lockPrice) headers.splice(2, 0, { key: 'lockPrice', name: 'Lock Price', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' });

			if (this.fob) {
				let idx = headers.findIndex(el => el.key === 'po_delivery_type_code');
				if (idx < 0) idx = headers.length;
				headers.splice(idx, 0, { key: 'fob', name: 'FOB', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' });
			}

			return headers;
		},
		async index() {
			const { data } = await apiIndex();
			this.classGroups = data.classGroupList;
			this.categories = data.categoryList;
		},
	},

	created() {
		this.setDefaultHeader();

		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_vendorAnalyzeItem');
		this.$store.commit('setSubTitle', 'Report -> Vendor Analyze Item');

		this.index();
	},
};
</script>

<style></style>
